import { atom } from 'jotai';

const pageDrawerOpenAtom = atom(false);

export default pageDrawerOpenAtom;
